import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MotifModalModule,
  MotifButtonModule,
  MotifIconModule,
  MotifTreeModule,
  MotifFormsModule,
} from '@ey-xd/ng-motif';

import { LoanApiService } from '../../_services/loan-api.service';
import { DataElementService } from '../../_services/dataElement.service';
import { CommonModule } from '@angular/common';

interface InstructionStep {
  InstructionAgent: string;
  InstructionStep: string;
  InstructionStepKey: string;
  InstructionType: string;
  InstructionValue: string;
}
@Component({
  selector: 'modal-update-instruction',
  standalone: true,
  imports: [
    MotifModalModule,
    CommonModule,
    MotifButtonModule,
    MotifIconModule,
    FormsModule,
    MotifTreeModule,
    MotifFormsModule,
  ],
  templateUrl: './modal-update-instruction.component.html',
  styleUrl: './modal-update-instruction.component.scss',
})
export class ModalUpdateInstructionComponent {
  @Input() instructionDetails: any;
  @Output() close = new EventEmitter<void>();
  @Input() title!: string;
  modalTittle: string = '';
  step: number = 1;
  stepDetails: InstructionStep[] = [
    {
      InstructionAgent: 'Retriever Agent',
      InstructionStep: '',
      InstructionStepKey: '',
      InstructionType: 'Retrieve',
      InstructionValue: '',
    },
    {
      InstructionAgent: 'Retriever Agent',
      InstructionStep: '',
      InstructionStepKey: '',
      InstructionType: 'Reranker',
      InstructionValue: '',
    },
    {
      InstructionAgent: 'LLM Agent',
      InstructionStep: '',
      InstructionStepKey: '',
      InstructionType: 'LLM',
      InstructionValue: '',
    },
  ];
  instructionName: string = '';
  params: any = {};
  newTag: string = '';
  dataElementDetails: any = {};
  TagList: string[] = [];
  toggleSwitch: boolean = false;
  constructor(
    private LoanApiService: LoanApiService,
    private _dataElementService: DataElementService
  ) {}
  ngOnInit() {
    this._dataElementService.basicRequestParams$.subscribe((params) => {
      this.params = { ...params };
      this.modalTittle = this.title;
    });
    const { version, instruction_steps } =
      this.instructionDetails?.instruction_step ?? {};
    this.initializeDetails(version, instruction_steps);
  }

  initializeDetails(
    version: {},
    instruction_steps: InstructionStep[] | undefined
  ) {
    this.dataElementDetails = version ?? {
      isLatest: this.toggleSwitch,
      Version: '',
    };
    if (this.dataElementDetails.Tags && this.dataElementDetails.Tags !== ' ') {
      this.TagList.push(
        ...this.dataElementDetails.Tags.split(',').map((tag: string) =>
          tag.trim()
        )
      );
    }
    this.stepDetails = instruction_steps ?? this.stepDetails;
  }
  onClose() {
    this.close.emit();
  }
  update() {
    this.LoanApiService.updateVersionStep(
      this.params,
      this.dataElementDetails,
      this.stepDetails,
      this.TagList
    ).subscribe({
      next: (response: any) => {
        this.close.emit();
      },
      error: (err: any) => {
        console.error('Update failed:', err);
      },
    });
  }
  addTag(tag: string): void {
    if (tag && !this.TagList.includes(tag)) {
      this.TagList.push(tag);
    }
    this.newTag = ''; // Clear the input field after adding the tag
  }

  removeTag(tag: string): void {
    if (!!this.TagList) {
      this.TagList = this.TagList.filter((t: string) => t !== tag);
    }
  }

  /* Validate Version */
  hasValidDataElementDetails() {
    // Validate that Version is not empty and isLatest is a boolean
    const { Version } = this.dataElementDetails;
    return typeof Version === 'string' && Version.trim() !== '';
  }

  toggle() {
    this.toggleSwitch = !this.toggleSwitch;
    this.dataElementDetails.isLatest = this.toggleSwitch;
  }
}
